import React, { Component } from "react";
import "./ToggleButton.css";

/**
 * @desc Toggle button
 * @version 1.0.0
 * @author Lakshmikanth V
 */
const ToggleButton = props => {
  const checked = props.isChecked ? true : false;
  return (
    <label class="toggle-container">
      <input
        type="checkbox"
        checked={checked}
        onClick={props.handleToggleStatus}
        disabled={props.disabled}
      />
      <span class="slider round" />
    </label>
  );
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/UI/ToggleButton/ToggleButton.js